import React, { useCallback } from 'react';
import moment from 'moment';

import { useAppDispatch } from 'utils/hooks';
import { ServerTimeFormat } from 'utils/constants';
import { tableMetaActions } from 'models/table-meta';
import { FilterBlock, FilterContainer } from './elements';
import { PathCreator, RoutePaths } from 'routing/constants';

import type { ITimeBlockFilter } from '../types';

export const pagePath = 'mobile_' + PathCreator[RoutePaths.BOOKING_LIST].path;

interface ITeeTimesFilterProps {
  value?: ITimeBlockFilter;
}

const timeIntervals = [
  { start: '8:00', end: '10:00' },
  { start: '10:00', end: '12:00' },
  { start: '12:00', end: '14:00' },
  { start: '14:00', end: '16:00' },
  { start: '16:00', end: '18:00' },
];

export const TeeTimesFilter = ({ value }: ITeeTimesFilterProps) => {
  const dispatch = useAppDispatch();

  const setFilters = useCallback(async (settings: ITimeBlockFilter) => {
    await dispatch(tableMetaActions.setFilters({
      path: pagePath,
      data: settings,
    }));
  }, [dispatch]);

  const onBlockClick = (settings: ITimeBlockFilter) => () => {
    setFilters(settings);
  }

  return (
    <FilterContainer>
      <FilterBlock onClick={onBlockClick({ interval: undefined })} $active={!value?.interval}>All</FilterBlock>

      {timeIntervals.map(interval => (
        <FilterBlock
          key={interval.start}
          onClick={onBlockClick({ interval })}
          $active={value?.interval?.start === interval.start}
        >
          {moment(interval.start, ServerTimeFormat).format('h A')} - {moment(interval.end, ServerTimeFormat).format('h A')}
        </FilterBlock>
      ))}
    </FilterContainer>
  );
};
